<template>
    <div class="modal fade" :id="'createTagModal_'+modalId" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <form @submit.prevent="submitData" class="form">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ !isEdit ? $t('tags.creation') : $t('tags.modification') }}</h5>
                        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                        fill="currentColor"/>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                        fill="currentColor"/>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <RequiredText />
                        <Input
                            containerClass="col-12 mt-2 mb-5"
                            :name="`${id}-name`"
                            type="text"
                            :label="$t('tags.name')"
                            labelClass="form-label"
                            :inputClass="'form-control form-control-lg form-control-solid'"
                            :placeholder="$t('tags.name')"
                            :isRequired="true" size="lg"
                            v-model="formData.name"
                        />
                    </div>
                    <div class="modal-footer">
                        <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
                        <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingTag"></Button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>

    import {ref, defineProps} from 'vue'
    import {useStore} from "vuex";
    import RequiredText from "@/components/RequiredText"
    import Button from "@/components/Button.vue"
    import OutlineButton from "@/components/OutlineButton.vue"
    import Input from "@/components/Input.vue";

    const store = useStore()

    const props = defineProps({
        tag: { 
            type: Object, 
            default: {
                name: ''
            } 
        },
        id: {
            type: String,
            required: true
        },
        parent: {
            type: String,
            required: false
        },
        isEdit: {
            type: Boolean,
            required: false
        }
    })

    const emits = defineEmits(['load', 'addTag'])

    const modalId = ref(props.id)

    const formData = ref(props.tag)
    const isLoadingTag = ref(false)

    function submitData(){
        if(!props.isEdit){
            createTagData()
        }else{
            updateTagData()
        }
    }

    function closeModal(){
        if(parent){
            $('#'+props.parent).modal('toggle')
        }
        $('#createTagModal_'+modalId.value).modal('toggle')
    }

    function createTagData() {
        isLoadingTag.value = true
        store.dispatch('tags/createTag', formData.value)
            .then((response) => {
                emits('addTag', response.data?.tag?.id)
                emits('load')
                isLoadingTag.value = false
                closeModal()
                formData.value.name = ''
                window.toastr['success'](i18n.global.t('notification.tag_created'))
            })
            .catch(err => {
                isLoadingTag.value = false
            })
    }

    function updateTagData() {
        isLoadingTag.value = true
        store.dispatch('brands/updateBrand', formData.value)
            .then((response) => {
                emits('load')
                isLoadingTag.value = false
                closeModal()
                formData.value.id = ''
                formData.value.name = ''
                window.toastr['success'](i18n.global.t('notification.tag_updated'))
            })
            .catch(err => {
                isLoadingTag.value = false
            })
    }
</script>